import React from "react";
import "./TermsConditions.css";

export default function TermsConditions() {
  return (
    <div className="policyPage">
      <div className="policyWrap">
        <h1 className="policyTitle">Terms of Service</h1>

        {/* ✅ CARD WRAPPER */}
        <div className="policyCard">
          <p className="policyIntro">
            Welcome to Ayrine. These Terms of Service (“Terms”) govern your access to and use of our website,
            products, and services. By visiting our website or placing an order, you agree to comply with the
            terms outlined below.
            <br /><br />
            If you do not agree with these Terms, please refrain from using our website.
          </p>

          {/* ===== sections unchanged ===== */}

          <section className="policySection">
            <h2>1. About Us</h2>
            <p>
              This website is owned and operated by Ayrine, based in Hyderabad, India.
              Throughout this document, “we,” “our,” and “us” refer to Ayrine.
            </p>
            <p>
              Our online store is powered by Shopify, which provides the infrastructure
              that enables us to offer our products and services.
            </p>
          </section>

          <section className="policySection">
            <h2>2. Eligibility to Use Our Website</h2>
            <p>By using this website, you confirm that:</p>
            <ul>
              <li>You are at least 18 years of age, or</li>
              <li>You are using the website under the supervision of a parent or legal guardian.</li>
            </ul>
            <p>You agree not to use our website for unlawful, fraudulent, or unauthorized purposes.</p>
          </section>

          <section className="policySection">
            <h2>3. Product Information & Pricing</h2>
            <p>We make every effort to present accurate product descriptions, images, and pricing. However:</p>
            <ul>
              <li>Colors may vary slightly due to screen settings and lighting differences.</li>
              <li>Product availability is subject to change without prior notice.</li>
              <li>We reserve the right to modify prices at any time.</li>
            </ul>
            <p>
              Placing an order does not guarantee acceptance. We reserve the right to cancel
              or refuse any order at our discretion.
            </p>
          </section>

          <section className="policySection">
            <h2>4. Orders & Payments</h2>
            <p>All orders are subject to confirmation and availability.</p>
            <p>
              You agree to provide accurate billing and shipping details while placing an order.
              Ayrine is not responsible for delays or issues arising from incorrect information
              provided by the customer.
            </p>
            <p>
              Payments are processed through secure third-party payment gateways integrated with Shopify.
              We do not store your full card details.
            </p>
          </section>

          <section className="policySection">
            <h2>5. Intellectual Property</h2>
            <p>
              All content on this website — including logos, designs, images, product descriptions,
              graphics, and text — is the exclusive property of Ayrine.
            </p>
            <p>
              You may not reproduce, copy, distribute, modify, or exploit any content from our
              website without prior written permission.
            </p>
          </section>

          <section className="policySection">
            <h2>6. User Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Upload or transmit malicious software, viruses, or harmful code</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Use our website for fraudulent activities</li>
              <li>Violate any applicable local, national, or international laws</li>
            </ul>
            <p>Violation of these Terms may result in termination of access to our services.</p>
          </section>

          <section className="policySection">
            <h2>7. Limitation of Liability</h2>
            <p>Ayrine does not guarantee that:</p>
            <ul>
              <li>The website will always be uninterrupted or error-free</li>
              <li>The website will be completely free from technical issues</li>
            </ul>
            <p>We are not liable for:</p>
            <ul>
              <li>Indirect or consequential damages</li>
              <li>Losses resulting from misuse of products</li>
              <li>Delays caused by third-party courier services</li>
              <li>Technical disruptions beyond our control</li>
            </ul>
            <p>Your use of our website and products is at your own risk.</p>
          </section>

          <section className="policySection">
            <h2>8. Returns, Exchanges & Refunds</h2>
            <p>
              All returns, exchanges, and refund matters are governed by our separate
              Shipping & Refund Policy. By placing an order, you acknowledge that you
              have reviewed and accepted those policies.
            </p>
          </section>

          <section className="policySection">
            <h2>9. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Ayrine, its owners, affiliates,
              and service providers from any claims, damages, or demands arising out of:
            </p>
            <ul>
              <li>Your breach of these Terms</li>
              <li>Your misuse of our website</li>
              <li>Your violation of applicable laws</li>
            </ul>
          </section>

          <section className="policySection">
            <h2>10. Privacy</h2>
            <p>
              Your submission of personal information is governed by our Privacy Policy.
              By using our website, you consent to the collection and use of your data as described therein.
            </p>
          </section>

          <section className="policySection">
            <h2>11. Changes to These Terms</h2>
            <p>
              We reserve the right to update or modify these Terms at any time without prior notice.
              Continued use of the website after updates constitutes acceptance of the revised Terms.
            </p>
          </section>

          <section className="policySection">
            <h2>12. Governing Law</h2>
            <p>
              These Terms shall be governed by and interpreted in accordance with the laws of India.
              Any disputes shall be subject to the jurisdiction of courts located in Hyderabad, Telangana.
            </p>
          </section>

          <section className="policySection">
            <h2>13. Contact Information</h2>
            <p>
              Ayrine<br />
              Tolichowki, Paramount Hills Colony Gate No 2<br />
              Opp. Paramount Heights<br />
              Paramount Hills, Toli Chowki<br />
              Hyderabad, Telangana – 500008<br />
              India
            </p>
            <p>📧 Email: info@ayrine.in</p>
          </section>
        </div>
      </div>
    </div>
  );
}